export default "{\n    \"placeholderText\": \"Group / Facility\",\n    \"searchPlaceholderText\": \"Search by group or facility name\"\n}\n"